import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomTab from "../../components/Common/CustomTab/CustomTab";
import MasterUploadTab from "./MasterUploadTab";
import {
    getCustomerGroupMasterList,
    uploadCustomerGroupMaster,
    downloadCustomerGroupMasterTemplate,
    getCustomerMasterList,
    uploadCustomerMaster,
    downloadCustomerMasterTemplate,
    getCpcMasterList,
    uploadCpcMaster,
    downloadCpcMasterTemplate,
} from "../../redux/masterUploadsSlice/masterUploadsSlice";

const tabData = [
    { label: "Customer Group Master" },
    { label: "Customer Master" },
    { label: "CPC Master" },
];

const customerGroupColumns = [
    { title: "Customer Group Code", dataIndex: "CUSTOMER_GROUP_CODE", key: "CUSTOMER_GROUP_CODE", width: 180 },
    { title: "Customer Group Name", dataIndex: "CUSTOMER_GROUP_NAME", key: "CUSTOMER_GROUP_NAME", width: 320, ellipsis: true },
    { title: "Customer Group Category", dataIndex: "CUSTOMER_GROUP_CATEGORY", key: "CUSTOMER_GROUP_CATEGORY", width: 200 },
];

const customerColumns = [
    { title: "Customer Code", dataIndex: "CUST_CODE", key: "CUST_CODE", width: 150 },
    { title: "Customer Name", dataIndex: "CUST_NAME", key: "CUST_NAME", width: 280, ellipsis: true },
    { title: "Customer Group", dataIndex: "CUST_GROUP", key: "CUST_GROUP", width: 180 },
    { title: "Customer Group Name", dataIndex: "CUSTOMER_GROUP_NAME", key: "CUSTOMER_GROUP_NAME", width: 280, ellipsis: true },
];

const cpcColumns = [
    { title: "Project Code", dataIndex: "PROJ_CODE", key: "PROJ_CODE", width: 160 },
    { title: "Project Name", dataIndex: "PROJ_NAME", key: "PROJ_NAME", width: 280, ellipsis: true },
    { title: "Customer Code", dataIndex: "CUST_CODE", key: "CUST_CODE", width: 160 },
    { title: "Customer Name", dataIndex: "CUST_NAME", key: "CUST_NAME", width: 280, ellipsis: true },
];

const MasterUploads = () => {
    const [activeTab, setActiveTab] = useState("0");

    const {
        customerGroupMasterList,
        customerGroupMasterPagination,
        gettingCustomerGroupMasterList,
        uploadingCustomerGroupMaster,
        downloadingCustomerGroupMasterTemplate,

        customerMasterList,
        customerMasterPagination,
        gettingCustomerMasterList,
        uploadingCustomerMaster,
        downloadingCustomerMasterTemplate,

        cpcMasterList,
        cpcMasterPagination,
        gettingCpcMasterList,
        uploadingCpcMaster,
        downloadingCpcMasterTemplate,
    } = useSelector((state) => state.masterUploads);

    return (
        <div className="p-4">
            <div className="mb-2">
                <h1 className="text-[18px] font-semibold text-[#344054]">Customer Master</h1>
                <p className="text-[13px] text-[#667085] mt-0.5">
                    Download templates, upload master data and view records.
                </p>
            </div>

            <CustomTab tabItems={tabData} activeTab={activeTab} setActiveTab={setActiveTab} />

            {activeTab === "0" && (
                <MasterUploadTab
                    title="Customer Group Master"
                    searchPlaceholder="Search by Group Code or Name"
                    rowKey="CUSTOMER_GROUP_CODE"
                    columns={customerGroupColumns}
                    requiredFields={[
                        { key: "CUSTOMER_GROUP_CODE", label: "Customer Group Code" },
                        { key: "CUSTOMER_GROUP_NAME", label: "Customer Group Name" },
                        { key: "CUSTOMER_GROUP_CATEGORY", label: "Customer Group Category" },
                    ]}
                    getList={getCustomerGroupMasterList}
                    uploadData={uploadCustomerGroupMaster}
                    downloadTemplate={downloadCustomerGroupMasterTemplate}
                    listData={customerGroupMasterList}
                    pagination={customerGroupMasterPagination}
                    gettingList={gettingCustomerGroupMasterList}
                    uploading={uploadingCustomerGroupMaster}
                    downloadingTemplate={downloadingCustomerGroupMasterTemplate}
                />
            )}

            {activeTab === "1" && (
                <MasterUploadTab
                    title="Customer Master"
                    searchPlaceholder="Search by Customer Code or Name"
                    rowKey="CUST_CODE"
                    columns={customerColumns}
                    requiredFields={[
                        { key: "CUST_CODE", label: "Customer Code" },
                        { key: "CUST_NAME", label: "Customer Name" },
                        { key: "CUST_GROUP", label: "Customer Group" },
                    ]}
                    getList={getCustomerMasterList}
                    uploadData={uploadCustomerMaster}
                    downloadTemplate={downloadCustomerMasterTemplate}
                    listData={customerMasterList}
                    pagination={customerMasterPagination}
                    gettingList={gettingCustomerMasterList}
                    uploading={uploadingCustomerMaster}
                    downloadingTemplate={downloadingCustomerMasterTemplate}
                />
            )}

            {activeTab === "2" && (
                <MasterUploadTab
                    title="CPC Master"
                    searchPlaceholder="Search by Project Code or Name"
                    rowKey="PROJ_CODE"
                    columns={cpcColumns}
                    requiredFields={[
                        { key: "PROJ_CODE", label: "Project Code" },
                        { key: "PROJ_NAME", label: "Project Name" },
                        { key: "CUST_CODE", label: "Customer Code" },
                    ]}
                    getList={getCpcMasterList}
                    uploadData={uploadCpcMaster}
                    downloadTemplate={downloadCpcMasterTemplate}
                    listData={cpcMasterList}
                    pagination={cpcMasterPagination}
                    gettingList={gettingCpcMasterList}
                    uploading={uploadingCpcMaster}
                    downloadingTemplate={downloadingCpcMasterTemplate}
                />
            )}
        </div>
    );
};

export default MasterUploads;
